import React, {useState} from 'react'
import CreateCollectionForm from '../../components/createCollectionForm'
import {withRouter} from 'react-router-dom'
import moment from 'moment'
import { LoadLayer } from '../../components/utils/shared/shared';
import {APIRequest} from '../../components/utils/shared/requests'
import { API,Auth } from 'aws-amplify';
import ConfirmCollection from '../../components/confirmCollection'
function CreateCollection(props){
    const [load, setLoad] = useState(false)
    const awbNumber = props.location
    const [confirmingShipment, setConfirmingShipment] = useState(false)
    const [shipmentPickup, setShipmentPickup] = useState({awbNumber: (props.location.awb ? props.location.awb : ""), pickupDate:moment().format(),pickupEarlyTime: '',pickupCloseTime: '', pickupDateTime: '', pickupLocation: ''})
    const [shipment, setShipment] = useState([])
    const [error, setError] = useState(false)
    const fetchShipment = () => {
      APIRequest(`/shipments?awb_number=${shipmentPickup.awbNumber}`).then(result => {setShipment(result);setErrorStatus(result);})
    }
    const setErrorStatus = (res) => {
      if (res.length === 0){
        setError(true)
      } else {
        setConfirmingShipment(true)
      }
    }
    const handleSubmit = () => {
        setLoad(true)
        var pickUpDateMoment = moment(shipmentPickup.pickupDate).format('YYYY-MM-DD')
        var pickupDateTimeStamp = shipmentPickup.pickupDateTime = moment(pickUpDateMoment + ' ' + shipmentPickup.pickupEarlyTime, "YYYY-MM-DD HH:mm:ss")
        shipmentPickup.pickupDateTime = pickupDateTimeStamp.format()
        Auth.currentSession().then(session => {
          API
          .post("LabShip", "/shipment_collection_request",
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{shipment: shipment.shipments[0], pickupDetails: shipmentPickup}})
          .then(resp => {
            setLoad(false)
            if (resp.status === 'success'){
              props.history.push({
                pathname: '/collection/success',
                state: { shipment: resp }
              })
            } else {
              setLoad(false)
              props.history.push({
                pathname: '/collection/fail',
                state: { shipment: resp }
              })
            }
          })
        })
       }
       let view;
       if (load){
         view = <LoadLayer load={load} label={"Loading..."} />
       } else {
         if (confirmingShipment){
            view = <ConfirmCollection error={error} showLayer={confirmingShipment} user={props.user} setConfirmingShipment={setConfirmingShipment} handleSubmit={handleSubmit} fetchShipment={fetchShipment} shipmentPickup={shipmentPickup} shipment={shipment} setShipmentPickup={setShipmentPickup} size={props.size} />
         } else {
          view = <CreateCollectionForm awbNumber={awbNumber} setError={setError} error={error} user={props.user} fetchShipment={fetchShipment} shipmentPickup={shipmentPickup} setShipmentPickup={setShipmentPickup} size={props.size} />
         }  
       }
    return view

}

export default withRouter(CreateCollection)